/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 *  Possible values: Scheduling = 0, Active = 1, Archived = 2, History = 3, Declined = 4, ContactProvided = 10, AddressProvided = 11, ServiceDetailsCompleted = 12, SlotsPresented = 13, PreviewShown = 14, Confirmed = 15
 */
export enum Routemize_Constants_RequestStatus {
    SCHEDULING = 'Scheduling',
    ACTIVE = 'Active',
    ARCHIVED = 'Archived',
    HISTORY = 'History',
    DECLINED = 'Declined',
    CONTACT_PROVIDED = 'ContactProvided',
    ADDRESS_PROVIDED = 'AddressProvided',
    SERVICE_DETAILS_COMPLETED = 'ServiceDetailsCompleted',
    SLOTS_PRESENTED = 'SlotsPresented',
    PREVIEW_SHOWN = 'PreviewShown',
    CONFIRMED = 'Confirmed',
}
